export const checkRules518: any[] = [
  { type: '518', key: 'isVoice', value: '是', method: '==' },
  { type: '518', key: 'significand', value: 10, method: '>=' },
  { type: '518', key: 'jiHuoNum1arrNum', value: 3, method: '>=' },
  { type: '518', key: 'zhiBoNum1', value: 2, method: '>=' },
  { type: '518', key: 'voiceTotal', value: 30, method: '>=' }
]
export const checkRulesToujiao: any[] = [
  { type: 'toujiao', key: 'isVoice', value: '是', method: '==' },
  [
    { type: 'toujiao', key: 'fuWuNum', value: 2, method: '>=' },
    { type: 'toujiao', key: 'baoJiaNum2', value: 1, method: '>=' }
  ],
  { type: 'toujiao', key: 'jiHuoNum2arrNum', value: 3, method: '>=' },
  { type: 'toujiao', key: 'jingPoNumArrNum', value: 1, method: '>=' },
  { type: 'toujiao', key: 'zhiBoNum2', value: 2, method: '>=' },
  { type: 'toujiao', key: 'voiceTotal', value: 30, method: '>=' }
]
